'use client';

import Link from "next/link";

import { forwardRef } from "react";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import Image from "../Image";

const ProjectCard = forwardRef(
  ({ to, project, selectedTagIds, setSelectedTags }, ref) => {
    return (
      <Link
        href={to}
        ref={ref}
        className="relative w-[302px] md:w-[392px] h-[216px] md:h-[262px] p-px rounded-md md:rounded-xl overflow-hidden group cursor-pointer transition-all duration-500"
      >
        {/* Rotating gradient background */}
        <div className="absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),#555_50%)] transition-transform duration-700 group-hover:rotate-180 blur-xl scale-150 opacity-60"></div>

        <div className="relative w-[300px] md:w-[390px] h-[214px] md:h-[260px] bg-cover overflow-hidden group rounded-md md:rounded-xl bg-[var(--bg-transparent-1)]">
          <div
            className="absolute inset-0 bg-cover bg-center grayscale-[90%]"
            style={{ backgroundImage: `url(${project.image})` }}
          ></div>

          {/* Overlay for better readability */}
          <div className="absolute inset-0 rounded-xl bg-gray-700/40 group-hover:bg-green-900/20 transition duration-300 backdrop-blur-sm"></div>

          {/* Top Floating Image */}
          <Image
            src={project.image}
            alt={project.name}
            className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[300px] md:w-[390px] h-[150px] md:h-[190px] scale-100 md:group-hover:scale-105 transition-all duration-700 z-10 md:grayscale-[90%] group-hover:grayscale-0"
          />

          {/* Project Tags */}
          <div className="absolute top-2 md:-top-2 group-hover:top-3 right-2 md:-right-4 group-hover:right-3 md:opacity-0 group-hover:opacity-100 flex gap-2 transition-all duration-300 z-10">
            {project.tags.map((tag, index) => (
              <span
                key={index}
                className={`flex justify-center items-center gap-2 text-xs px-2 py-1 rounded-full border text-center bg-color-96 transition-all duration-300 ${
                  selectedTagIds.includes(tag.id)
                    ? "text-color-1 border-color-50 bg-color-95 font-medium"
                    : "border-color-97 hover:border-color-50 text-color-1 hover:text-color-1"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setSelectedTags(tag.id);
                }}
              >
                {tag.tag}
              </span>
            ))}
          </div>

          {/* Project Info */}
          <div className="absolute bottom-0 w-full p-3 pt-32 bg-gradient-to-t from-black/95 to-transparent z-20">
            <h3 className="text-white text-lg font-semibold line-clamp-1">{project.name}</h3>
            <p className="text-gray-300 text-sm line-clamp-2">{project.description}</p>
          </div>

          {/* Redirect Icon (card itself is the link) */}
          <span className="absolute bottom-4 right-4 z-30 text-color-1 p-2 group-hover:text-[--accent-light] group-hover:scale-125 font-thin rounded-full shadow-lg transition-all duration-700">
            <FaArrowUpRightFromSquare />
          </span>
        </div>
      </Link>
    );
  }
);

// Add display name for better debugging
ProjectCard.displayName = "ProjectCard";

export default ProjectCard;
